// extracted by mini-css-extract-plugin
export default {"sloped":"Section_sloped__+HldM"};